import { Text } from '@bnnvara/typography';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemeTagArticle } from '../Tags/ThemeTagArticle';

import * as S from './styled';

const BaseMetaBlock = ({
  publicationDate,
  duration,
  categories,
  viewCount,
  subThemes,
  children,
}) => {
  const showCategories = categories && categories.length !== 0;
  const currentSubThemeSlug = useRouter().query.theme;
  let currentSubTheme = currentSubThemeSlug
    ? subThemes.filter((obj) => {
        return obj.slug === currentSubThemeSlug;
      })[0]
    : subThemes[0];
  // Falback to show theme when wrong currentSubThemeSlug
  currentSubTheme = currentSubTheme || subThemes[0];
  const hideOnProduction = process.env.NODE_ENV !== 'production';

  return (
    <S.BaseMetaBlockDataContainer>
      <S.DateTimeContainer>
        <S.Row>
          {showCategories && (
            <>
              <S.CategoryContainer>{categories}</S.CategoryContainer>
              <span>&nbsp; &bull; &nbsp;</span>
            </>
          )}
          {currentSubTheme && hideOnProduction && (
            <>
              <ThemeTagArticle
                themeSlug={currentSubTheme.parentSlug}
                href={`/thema/${currentSubTheme.parentSlug}/${currentSubTheme.slug}`}
              >
                {currentSubTheme.name}
              </ThemeTagArticle>
              <span>&nbsp; &bull; &nbsp;</span>
            </>
          )}
          <Text>{publicationDate}</Text>
          {duration && (
            <>
              <span>&nbsp; &bull; &nbsp;</span>
              <Text>{duration}</Text>
              <S.Dot>&nbsp; &bull; &nbsp;</S.Dot>
            </>
          )}
        </S.Row>
        <S.Row>
          {viewCount >= 50 && (
            <>
              <Text>{viewCount} keer bekeken</Text>
              <span>&nbsp; &bull; &nbsp;</span>
            </>
          )}
          {children}
        </S.Row>
      </S.DateTimeContainer>
    </S.BaseMetaBlockDataContainer>
  );
};

BaseMetaBlock.defaultProps = {
  duration: null,
  categories: null,
  subThemes: [],
  viewCount: 0,
};

BaseMetaBlock.propTypes = {
  publicationDate: PropTypes.string.isRequired,
  duration: PropTypes.string,
  categories: PropTypes.node,
  viewCount: PropTypes.number,
  subThemes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      slug: PropTypes.string,
      backgroundImageUrl: PropTypes.string,
      backgroundImageMobileUrl: PropTypes.string,
      parentSlug: PropTypes.string,
      parent: {
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        slug: PropTypes.string,
        backgroundImageUrl: PropTypes.string,
        backgroundImageMobileUrl: PropTypes.string,
      },
    })
  ),
  children: PropTypes.node,
};

export { BaseMetaBlock };
